<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <h1>Emerges</h1>
    <div class="white-body">
        <a mat-button class="btn-primary add-user" routerLink="/support/emerges-register"><mat-icon aria-hidden="false" aria-label="Plus">add</mat-icon> Cadastrar emerges</a>
        <div class="filters">
            <div class="row">   
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix class="my-icon">search</mat-icon>
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText" (keyup)="onKeySearch($event)">
                    </mat-form-field>
                </div>

            </div>
        </div>
        <div class="card-list" *ngIf="listEmerges != null">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of listEmerges">
                    <div class="card-item">
                        <div class="infos">
                            <span class="primary">{{item.healthUnitName}}</span>
                            <span class="secundary last-info">{{item.cnpj}}</span>
                        </div>
                        <div class="actions">
                            <a><mat-icon aria-hidden="false" aria-label="Editar" [routerLink] = "['/support/emerges-register', {idEmerges: item.idEmerges}]">edit</mat-icon> </a>
                            <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="openModal(item.idEmerges)">delete_forever</mat-icon> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-empty-list *ngIf="listEmerges != undefined && listEmerges.length == 0"></app-empty-list>
    </div>

    <app-loading-list *ngIf="isLoading"></app-loading-list>
</div>